var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { startOfMonth, endOfMonth } from 'date-fns';
import { CardApiClient } from './cardApiClient';
import { asISODateString } from '../utils';
import { filtersToParams } from '../utils/filtersUtils';
import { serializeParams } from '../utils/queryStringUtils';
function buildCalendarParams(_a) {
    var filters = _a.filters, monthAndYear = _a.monthAndYear, currency = _a.currency;
    var params = __assign(__assign({}, filtersToParams(__assign({}, filters))), { currency: currency });
    var referenceDate = new Date(monthAndYear.year, monthAndYear.month);
    if (referenceDate)
        params['date_from'] = asISODateString(startOfMonth(referenceDate));
    if (referenceDate)
        params['date_to'] = asISODateString(endOfMonth(referenceDate));
    return serializeParams(params);
}
export function getCalendarCollected(params) {
    return CardApiClient.get("/v2/dashboard/calendar_paid?" + buildCalendarParams(params)).then(function (response) { return response.data.data; });
}
export function getCalendarSold(params) {
    return CardApiClient.get("/v2/dashboard/calendar_sold?" + buildCalendarParams(params)).then(function (response) { return response.data.data; });
}
export function getMonthlyChargebacks() {
    return CardApiClient.get('/v2/dashboard/chargeback_totals').then(function (response) { return response.data.chargebacks; });
}
export function getCollectToday() {
    return CardApiClient.get('/v2/dashboard/collect_today').then(function (response) { return response.data.collect_today; });
}
export function getCollectTomorrow() {
    return CardApiClient.get('/v2/dashboard/collect_tomorrow').then(function (response) { return response.data.collect_tomorrow; });
}
